import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-cream-dark py-24 md:py-32 relative overflow-hidden" data-id="element-97">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-main/30 to-transparent" data-id="element-98"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-main/30 to-transparent" data-id="element-99"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-10" data-id="element-101">
          <div className="space-y-4" data-id="element-102">
            <p className="font-lora text-xl text-brown-light italic" data-id="element-103">
              Algunos libros informan.
            </p>
            <h2 className="text-3xl md:text-5xl font-playfair font-bold text-brown-dark leading-tight" data-id="element-104">
              Este libro transforma la forma en que vives los momentos
              importantes de tu vida.
            </h2>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-sm shadow-sm border border-gold-main/10 max-w-2xl mx-auto" data-id="element-105">
            <p className="font-lora text-lg text-brown-dark mb-6" data-id="element-106">
              Si sientes que necesitas:
            </p>
            <ul className="space-y-3 font-lora text-brown-light text-left max-w-xs mx-auto mb-8" data-id="element-107">
              <li className="flex items-center gap-3" data-id="element-108">
                <span className="text-gold-main" data-id="element-109">✦</span> cerrar ciclos
              </li>
              <li className="flex items-center gap-3" data-id="element-110">
                <span className="text-gold-main" data-id="element-111">✦</span> sanar emociones
              </li>
              <li className="flex items-center gap-3" data-id="element-112">
                <span className="text-gold-main" data-id="element-113">✦</span> crear espacios con
                sentido
              </li>
              <li className="flex items-center gap-3" data-id="element-114">
                <span className="text-gold-main" data-id="element-115">✦</span> honrar momentos
                importantes
              </li>
            </ul>
            <p className="font-playfair font-semibold text-xl text-gold-dark italic" data-id="element-116">
              entonces este libro fue creado para ti.
            </p>
          </div>

          <div className="space-y-6 pt-4" data-id="element-117">
            <p className="font-lora text-lg text-brown-dark" data-id="element-118">
              Accede hoy mismo por solo{' '}
              <span className="font-bold text-2xl text-gold-dark" data-id="element-119">
                $7.99 USD
              </span>
            </p>
            <CTAButton className="px-12 py-5 text-xl" data-id="element-120">
              Quiero empezar ahora
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}